import { render, staticRenderFns } from "./VuesticFileUploadSingleItem.vue?vue&type=template&id=7c06588e"
import script from "./VuesticFileUploadSingleItem.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadSingleItem.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUploadSingleItem.vue?vue&type=style&index=0&id=7c06588e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c06588e')) {
      api.createRecord('7c06588e', component.options)
    } else {
      api.reload('7c06588e', component.options)
    }
    module.hot.accept("./VuesticFileUploadSingleItem.vue?vue&type=template&id=7c06588e", function () {
      api.rerender('7c06588e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload/VuesticFileUploadSingleItem.vue"
export default component.exports